/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2024, Zumper
 */

import { buildingReviewsDataReducer, buildingReviewsWhitelist } from '@zcode-ui/web-zumper-features'
import { filterActions } from '@zumper/redux-ignore'
import type { ActionTypes as DetailActionTypes } from '../../reducers/types'
// import { whitelist } from './reducers/whitelist'

export const buildingReviews = filterActions<
  ReturnType<typeof buildingReviewsDataReducer>,
  DetailActionTypes,
  (typeof buildingReviewsWhitelist)[number]
>(buildingReviewsDataReducer, buildingReviewsWhitelist)
